import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const TransactionList = Loadable(lazy(() => import('pages/TransactionList')));
const TransactionUpdate = Loadable(lazy(() => import('pages/TransactionUpdate')));
const TransactionPrint = Loadable(lazy(() => import('pages/TransactionPrint')));
const BillGeneration = Loadable(lazy(() => import('pages/BillGeneration')));
const BillSummary = Loadable(lazy(() => import('pages/BillSummary')));
const BankList = Loadable(lazy(() => import('pages/BankList')));
const BankUpdate = Loadable(lazy(() => import('pages/BankUpdate')));
const AgentList = Loadable(lazy(() => import('pages/AgentList')));
const AgentUpdate = Loadable(lazy(() => import('pages/AgentUpdate')));
const Logout = Loadable(lazy(() => import('pages/Logout')));

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <TransactionList />
    },
    {
      path: 'transaction',
      children: [
        {
          path: 'bill',
          element: <BillGeneration />
        },
        {
          path: 'summary',
          element: <BillSummary />
        },
        {
          path: 'update/:id',
          element: <TransactionUpdate />
        },
        {
          path: 'print/:id',
          element: <TransactionPrint />
        },
        {
          path: 'default',
          element: <TransactionList />
        }
      ]
    },
    {
      path: 'bank',
      children: [
        {
          path: 'update/:id',
          element: <BankUpdate />
        },
        {
          path: 'default',
          element: <BankList />
        }
      ]
    },
    {
      path: 'agent',
      children: [
        {
          path: 'update/:id',
          element: <AgentUpdate />
        },
        {
          path: 'default',
          element: <AgentList />
        }
      ]
    },
    {
      path: 'logout',
      children: [
        {
          path: 'default',
          element: <Logout />
        }
      ]
    }
  ]
};

export default MainRoutes;
